export default {
    props: {
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }, 
        tooltip: {
            type: String,
            default: undefined,
            kComposite: 'tooltip'
        }, 
        exec: {
            type: Function,
            default: undefined,
            kComposite: 'exec'
        }, 
        items: {
            type: Array,
            default: undefined,
            kComposite: 'items'
        }, 
        palette: {
            type: [String, Array],
            default: undefined,
            kComposite: 'palette'
        }, 
        columns: {
            type: Number,
            default: undefined,
            kComposite: 'columns'
        }, 
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditorTool/Tools.js